interface IRuntimeConfig {
  ASSUME_ROLE_ENABLED: boolean;
  LOYALTY_API_ROOT: string;
}

export const BASE_URL = process.env.BASE_URL as string;
export const API_BASE_URL = process.env.VUE_APP_API_ROOT as string;
export const LOYALTY_BASE_URL = process.env.VUE_APP_LOYALTY_API_ROOT as string;
export const DECLINED_TRANSACTIONS_API_BASE_URL = process.env.VUE_APP_DECLINED_TRANSACTIONS_API_ROOT as string;
export const OLA_BASE_URL = process.env.VUE_APP_OLA_ROOT as string;
export const AD_APP_INSTANCE = process.env.VUE_APP_AD_INSTANCE as string;
export const AD_APP_TENANT = process.env.VUE_APP_AD_TENANT as string;
export const AD_APP_CLIENTID = process.env.VUE_APP_AD_CLIENTID as string;
export const OLA_API_AD_APP_ID = process.env.VUE_APP_OLA_API_AD_APP_ID as string;
export const LOYALTY_API_AD_APP_ID = process.env.VUE_APP_LOYALTY_API_AD_APP_ID as string;
export const DECLINED_TRANSACTIONS_APP_ID = process.env.VUE_APP_DECLINED_TRANSACTIONS_APP_ID as string;

const runtimeConfig = (window as any).env as IRuntimeConfig;

export const ASSUME_ROLE_ENABLED = runtimeConfig.ASSUME_ROLE_ENABLED;
